window.addEventListener("load", function () {
  // Load all formie forms with AJAX to prevent bots from finding the forms.
  let formieForms = document.querySelectorAll('.formie-form');
  let loadingIndicator = document.querySelector('.loading-indicator[data-loading="true"');
  for (var i = 0; i < formieForms.length; i++) {
    let formieForm = formieForms[i];
    $.ajax({
      url: ALANDSBANKEN.siteUrl + 'actions/alandsbanken/alandsbanken/formie-form',
      type: 'get',
      dataType: 'json',
      headers: {
        'Accept': 'application/json'
      },
      data: {
        formId: formieForms[i].dataset.formId,
        requestPath: formieForms[i].dataset.requestPath,
      }
    }).done((response) => {
      formieForm.innerHTML = response.html;
      if (!!Formie) {
        let form = formieForm.querySelector('form');
        if (formieForm.closest('.new-form')) {
          form.classList.add('new-form');
        };
        Formie.initForm(form);

        if (loadingIndicator) {
          loadingIndicator.dataset.loading = false;
          loadingIndicator.style.display = "none";
        }

        // Find the CSRF token hidden input, so we can replace it
        let $csrfInput = form.querySelector('input[name="CRAFT_CSRF_TOKEN"]');
        let $formHandle = form.querySelector('input[name="handle"]').value;

        // Fetch the new token for the form and replace the CSRF input with our new one
        fetch('/actions/formie/forms/refresh-tokens?form=' + $formHandle)
          .then(result => { return result.json(); })
          .then(result => { $csrfInput.outerHTML = result.csrf.input; });
      }
    });
  }
});